import { array, InferOutput, nullable, number, strictObject, string, unknown } from 'valibot'
import type { StateRowTransportValue } from '../../../backend.d'
import { ProfileIdSchema } from '../ProfileId.type'
import { StateOnlineIdSchema } from '../state/StateOnlineId.type'
import { StateSchema } from '../state/State.type'
import { StateBytesSchema } from '../state/persisted_state'

export const WorkspaceMapFileIdSchema = string()

export type WorkspaceMapFileId = InferOutput<typeof WorkspaceMapFileIdSchema>

const WorkspaceMapProfileSchema = strictObject({
  id: ProfileIdSchema,
  handle: nullable(string()),
  dname: nullable(string()),
  avatar_id: nullable(number()),
})

export const WorkspaceMapFileSchema = strictObject({
  id: StateOnlineIdSchema,
  data: StateBytesSchema,
  action_logs: array(unknown()),
  created_at: string(),
  updated_at: string(),
  published_at: nullable(string()),
  deleted_at: nullable(string()),
  creator: WorkspaceMapProfileSchema,
  owner: WorkspaceMapProfileSchema,
  turn: nullable(WorkspaceMapProfileSchema),
})

export type WorkspaceMapFile = InferOutput<typeof WorkspaceMapFileSchema>

export const WorkspaceMapLegacyFileSchema = strictObject({
  id: StateOnlineIdSchema,
  data: StateSchema,
  action_logs: array(unknown()),
  created_at: string(),
  updated_at: string(),
  published_at: nullable(string()),
  deleted_at: nullable(string()),
  creator: WorkspaceMapProfileSchema,
  owner: WorkspaceMapProfileSchema,
  turn: nullable(WorkspaceMapProfileSchema),
})

export type WorkspaceMapLegacyFile = InferOutput<typeof WorkspaceMapLegacyFileSchema>

export const WorkspaceMapIndexEntrySchema = strictObject({
  file_id: WorkspaceMapFileIdSchema,
})

export type WorkspaceMapIndexEntry = InferOutput<typeof WorkspaceMapIndexEntrySchema>

export const WorkspaceMapIndexSchema = array(WorkspaceMapIndexEntrySchema)

export type WorkspaceMapIndex = InferOutput<typeof WorkspaceMapIndexSchema>

export const WorkspaceMapEntrySchema = strictObject({
  file_id: WorkspaceMapFileIdSchema,
  row: WorkspaceMapFileSchema,
})

export type WorkspaceMapEntry = InferOutput<typeof WorkspaceMapEntrySchema>

export const WorkspaceMapIndexResponseSchema = strictObject({
  workspaceMapIndex: WorkspaceMapIndexSchema,
})

export type WorkspaceMapIndexResponse = InferOutput<typeof WorkspaceMapIndexResponseSchema>

export const WorkspaceMapLoadRequestSchema = strictObject({
  file_id: WorkspaceMapFileIdSchema,
})

export type WorkspaceMapLoadRequest = InferOutput<typeof WorkspaceMapLoadRequestSchema>

export const WorkspaceMapLoadResponseSchema = strictObject({
  entry: WorkspaceMapEntrySchema,
})

export type WorkspaceMapLoadResponse = InferOutput<typeof WorkspaceMapLoadResponseSchema>

export const WorkspaceMapSaveRequestSchema = strictObject({
  entry: WorkspaceMapEntrySchema,
})

export type WorkspaceMapSaveRequest = InferOutput<typeof WorkspaceMapSaveRequestSchema>

export const WorkspaceMapSaveResponseSchema = strictObject({
  entry: WorkspaceMapEntrySchema,
})

export type WorkspaceMapSaveResponse = InferOutput<typeof WorkspaceMapSaveResponseSchema>

export type WorkspaceMapSourceRow = StateRowTransportValue
